import styled from "styled-components";
import { Button, Form } from "react-bootstrap";
import { MdSearch } from "react-icons/md";

export const FormFilter = styled.div`
  display: flex;
  margin: 24px 0px;
  gap: 8px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const ViewFilter = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-right: 8px;
  width: 117px;
  height: 44px;
  color: #264259;
  border: 1.5px solid #e1e6ef;
  border-radius: 8px;
`

export const SelectFilter = styled(Form.Select)`
  border: 1.5px solid #e1e6ef;
  border-radius: 0;
  font-family: "Roboto";
  font-style: normal;
  margin: 0px 24px;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  max-width: 142px;
  height: 44px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

export const BoxSearch = styled.div`
  display: flex;
  align-items: center;
  width: 360px;
  border-radius: 8px 0 0 8px;
  height: 44px;
  background: #f3f5fb;
  border: 1.5px solid #e1e6ef;
  padding-left: 10px;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

export const IconSearch = styled(MdSearch)`
  color: #1e212a;
`;

export const InputSearch = styled.input`
  border: none;
  background: none;
  outline: none !important;
`;

export const ButtonSearch = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  border: none !important;
  border-radius: 0 4px 4px 0;
`;

export const ButtonClearSearch = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  border: none !important;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
`;